import React, {memo} from 'react'

import {useSyncedQueryParam} from '../../../../hooks/routes'
import {useBuildData} from '../../../../hooks/useEntity'
import type {BuildId} from '../../../../types'
import {BuildPageTabNamesEnum} from '../../../../types'
import {UserProperties} from '../../../../utils/userProperties'
import ClassicUITabAdapter from '../../../common/ClassicUITabAdapter/ClassicUITabAdapter'
import ModeSwitch, {Mode} from '../../../common/ModeSwitch/ModeSwitch'
import {ParametersGroupControls} from '../../../packages/Parameters/components/GroupControls/ParametersGroupControls'

import {buildParametersTabParam} from './BuildParameters.constants'
import {BuildParametersKindTab} from './BuildParameters.types'
import {useQueryBuildSubscriptionForParameters} from './hooks/useQueryBuildSubscriptionForParameters'
import {BuildParameters} from './Parameters/BuildParameters'

import styles from './BuildParametersTab.css'

interface Props {
  buildId: BuildId
}

function BuildParametersTabComponent(props: Props) {
  const {buildId} = props

  useQueryBuildSubscriptionForParameters(buildId)

  const buildState = useBuildData({buildId}, build => build?.state)

  const [mode, setMode] = useSyncedQueryParam({
    param: buildParametersTabParam,
    userProperty: UserProperties.BUILD_PARAMETERS_TAB,
    skip: true,
  })

  return (
    <ModeSwitch
      userProperty={UserProperties.BUILD_PARAMETERS_TAB}
      preserveParams={({buildTab}) => ({buildTab})}
      param={buildParametersTabParam}
      customItems={
        mode === BuildParametersKindTab.PARAMETERS && (
          <ParametersGroupControls className={styles.controls} />
        )
      }
    >
      <Mode mode={BuildParametersKindTab.PARAMETERS} label="Parameters">
        <BuildParameters buildId={buildId} />
      </Mode>
      <Mode
        mode={BuildParametersKindTab.STATISTICS}
        isDisabled={buildState === 'queued'}
        label="Statistic Values"
      >
        <ClassicUITabAdapter
          tabId={BuildPageTabNamesEnum.buildParameters}
          title={''}
          buildId={buildId}
          statistics
          onURLChange={url => {
            if (!url.includes('buildParametersTab=statistics')) {
              setMode(BuildParametersKindTab.PARAMETERS)
              return true
            }
            return false
          }}
        />
      </Mode>
    </ModeSwitch>
  )
}

export const BuildParametersTab = memo<Props>(BuildParametersTabComponent)
